import { SetupContext, ref, computed } from "@vue/composition-api";
import { ActionPlanResultsProps } from "../types/actionPlanResults";
import { getUnitsAsDrinks } from "@dcc/score/weekly";
import { getCaloriesAsBurgers } from "@dcc/score/conversions";
import { getActions } from "@dcc/store/activity/actions";
import { Activity } from "@dcc/types/activity";
import { findGetters } from "@dcc/store/activity/getters";
import { findGetters as findScoreGetters } from "@dcc/store/score/getters";
import { findGetters as findDrinkingGetters } from "@dcc/store/drinking/getters";
import { DrinkingDay } from "@dcc/types/drinkingDay";

export const useActionPlanResults = (
  context: SetupContext,
  props: ActionPlanResultsProps
) => {
  let caloriesPerWeek: number;
  let unitsPerWeek: number;
  let unitsAsDrinks: DrinkingDay;
  let caloriesAsCheeseburgers: number;

  const {
    getWeeklyUnitsAndCalories,
    getWeeklyUnitsAsDrinks,
    getWeeklyCaloriesAsBurgers
  } = findScoreGetters(context.root.$store);

  if (props.calories_week && props.units_week) {
    caloriesPerWeek = props.calories_week ? props.calories_week : 0;
    unitsPerWeek = props.units_week ? props.units_week : 0;
    unitsAsDrinks = getUnitsAsDrinks(unitsPerWeek);
    caloriesAsCheeseburgers = getCaloriesAsBurgers(caloriesPerWeek);
  } else {
    const weeklyUnitsAndCalories = getWeeklyUnitsAndCalories().value;
    caloriesPerWeek = weeklyUnitsAndCalories.calories;
    unitsPerWeek = weeklyUnitsAndCalories.units;
    unitsAsDrinks = getWeeklyUnitsAsDrinks().value;
    caloriesAsCheeseburgers = getWeeklyCaloriesAsBurgers().value;
  }

  const { getAllActivities, getSelectedActivities } = findGetters(
    context.root.$store
  );

  let activities = ref<readonly Activity[]>(null);
  if (props.tips) {
    const { fetchActivities } = getActions(context.root.$store);
    fetchActivities({
      numDrinkingDaysInput: props.num_drinking_days,
      genderInput: props.gender
    });

    activities = computed(() => {
      const allActivities = getAllActivities().value;
      const response = allActivities.filter((a) => props.tips.includes(a.id));
      return response;
    });
  } else {
    activities = getSelectedActivities();
  }

  const { getTargetPercentage, getSelectedDrinkFreeDays } = findDrinkingGetters(
    context.root.$store
  );

  const targetPercentage = props.percentage
    ? props.percentage
    : getTargetPercentage().value || 0;

  const drinkFreeDays = props.dropped_days
    ? props.dropped_days
    : getSelectedDrinkFreeDays().value.length;

  const hasDrinkFreeDays = drinkFreeDays > 0;

  return {
    caloriesPerWeek,
    unitsPerWeek,
    unitsAsDrinks,
    caloriesAsCheeseburgers,
    activities,
    targetPercentage,
    hasDrinkFreeDays
  };
};
